// ===========================================================================
// Catálogo de cargos de las personas de una empresa del CRM.
// ===========================================================================
// El cargo se elige de aquí (no es texto libre), agrupado por área. El backend
// valida contra la misma lista y usa el área para decidir, por ejemplo, a quién
// le llega la factura (Finanzas primero).
//
// Espejo de apps/torre-de-control-api/functions/src/modules/crmCompanies/contactRoles.js:
// si cambias una, cambia la otra.
// ===========================================================================

export interface ContactRoleArea {
  id: string;
  label: string;
  roles: string[];
}

export const ROLE_CATALOG: ContactRoleArea[] = [
  {
    id: "direccion",
    label: "Dueños y dirección",
    roles: ["Dueño / Socio", "Director general", "Director de operaciones", "Director de finanzas", "Director comercial", "Director de tecnología", "Gerente general"],
  },
  {
    id: "finanzas",
    label: "Finanzas",
    roles: ["Gerente de finanzas", "Contador", "Cuentas por pagar", "Cuentas por cobrar", "Tesorería", "Facturación"],
  },
  {
    id: "administracion",
    label: "Administración",
    roles: ["Gerente administrativo", "Administrador", "Asistente administrativo", "Compras", "Recursos humanos", "Legal", "Recepción"],
  },
  {
    id: "operaciones",
    label: "Operaciones",
    roles: ["Gerente de operaciones", "Jefe de logística", "Coordinador de tráfico", "Jefe de flota", "Supervisor", "Despachador", "Mantenimiento", "Almacén", "Operador / Conductor", "Seguridad"],
  },
  {
    id: "comercial",
    label: "Comercial",
    roles: ["Gerente comercial", "Ventas", "Marketing", "Atención a clientes"],
  },
  {
    id: "ti",
    label: "TI",
    roles: ["Gerente de TI", "Sistemas", "Desarrollador", "Soporte técnico"],
  },
  {
    id: "staff",
    label: "Staff",
    roles: ["Staff / Colaborador", "Consultor externo", "Otro"],
  },
];
